import { ApiRoutes } from '@/settings/routes';
import Axios from 'axios';

const axios = Axios.create({
    baseURL: ApiRoutes.API_ROUT,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
    },
    withCredentials: true,
    withXSRFToken: true
});

export default axios;
